import { BasicContent } from './BasicContent';
import RichText from './RichText';
import Translation from '../../Translation';

const CMSTranslation = ({ ...content }) => (
  <>
    <BasicContent {...content.copy} />
    <Translation />
    <RichText content={content.footnotes} />
  </>
);

export default CMSTranslation;
